(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sandluz-direct-checkout')) {
    customElements.define(
      'sandluz-direct-checkout',
      class SandluzDirectCheckout extends HTMLElement {
        connectedCallback() {
          if (this.dataset.purchaseMode !== 'checkout_only') return;

          this.form = this.querySelector('form');
          this.structuralSubmit = this.querySelector('[data-direct-checkout-structural-submit]');
          this.primary = this.querySelector('[data-direct-checkout-primary]');
          this.status = this.querySelector('[data-direct-checkout-status]');
          this.note = this.querySelector('[data-direct-checkout-note]');
          this.noteCount = this.querySelector('[data-direct-checkout-note-count]');
          if (!this.form || !this.structuralSubmit || !this.primary || !this.status) return;

          this.handleKeydown = this.handleKeydown.bind(this);
          this.syncAvailability = this.syncAvailability.bind(this);
          this.updateNoteCount = this.updateNoteCount.bind(this);

          this.keydownScope = this.closest('product-info') || this.form;
          this.keydownScope.addEventListener('keydown', this.handleKeydown);
          this.note?.addEventListener('input', this.updateNoteCount);
          this.updateNoteCount();

          this.availabilityObserver = new MutationObserver(this.syncAvailability);
          this.availabilityObserver.observe(this.structuralSubmit, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class'],
          });

          this.checkoutObserver = new MutationObserver(() => this.updateCheckoutReady());
          this.checkoutObserver.observe(this.primary, { childList: true, subtree: true });

          this.syncAvailability();
          this.updateCheckoutReady();
        }

        handleKeydown(event) {
          if (event.key !== 'Enter' || event.defaultPrevented) return;
          if (!(event.target instanceof HTMLElement)) return;
          if (
            event.target.matches('textarea, button, [type="submit"], [type="button"], a, summary') ||
            event.target.closest('shopify-accelerated-checkout, .shopify-payment-button')
          ) {
            return;
          }

          const belongsToDirectForm =
            event.target.form === this.form || event.target.closest('form') === this.form;
          if (belongsToDirectForm) event.preventDefault();
        }

        updateNoteCount() {
          if (!this.note || !this.noteCount) return;
          this.noteCount.textContent = this.note.value.length + '/500';
        }

        updateCheckoutReady() {
          if (!this.primary) return;
          const ready = Boolean(
            this.primary.querySelector(
              'shopify-accelerated-checkout, .shopify-payment-button__button'
            )
          );
          this.primary.setAttribute('aria-busy', (!ready).toString());
        }

        syncAvailability() {
          const unavailable =
            this.structuralSubmit.disabled || this.structuralSubmit.getAttribute('aria-disabled') === 'true';
          const label = this.structuralSubmit.querySelector('span:not(.sold-out-message)')?.textContent?.trim();

          this.primary.hidden = unavailable;
          this.status.hidden = !unavailable;
          if (unavailable && label) this.status.textContent = label;
        }

        disconnectedCallback() {
          this.keydownScope?.removeEventListener('keydown', this.handleKeydown);
          this.note?.removeEventListener('input', this.updateNoteCount);
          this.availabilityObserver?.disconnect();
          this.checkoutObserver?.disconnect();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
